import { StatsCardProps } from './StatsCard.type';

export function StatsCard({
  title,
  value,
  variant = 'simple',
  items = [],
}: StatsCardProps) {
  const renderSimple = () => (
    <dd className="text-2xl text-left font-medium text-gray-900 leading-10">
      {value}
    </dd>
  );

  const renderBreakdown = () => (
    <div className="flex flex-col gap-2 lg:gap-0 lg:flex-row lg:justify-between">
      {items.map((item, index) => (
        <div key={index} className="flex flex-col w-full">
          <span className="text-sm leading-5 text-left font-medium text-gray-900v2">
            {item.label}:
          </span>
          <span className="text-sm leading-5 text-left font-medium text-gray-900v2">
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );

  const renderRisk = () => (
    <div className="flex flex-col gap-2 lg:gap-2 lg:flex-row justify-between">
      {items.map((item, index) => (
        <div key={index} className="flex flex-col w-full">
          <span
            className={`text-sm leading-5 text-left font-medium ${
              item.textColor || 'text-gray-900v2'
            }`}
          >
            {item.label}:
          </span>
          <span
            className={`text-sm leading-5 text-left font-medium ${
              item.textColor || 'text-gray-900v2'
            }`}
          >
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );

  const renderContent = () => {
    switch (variant) {
      case 'breakdown':
        return renderBreakdown();
      case 'risk':
        return renderRisk();
      default:
        return renderSimple();
    }
  };

  return (
    <div className="flex flex-col rounded-lg bg-white ring-1 ring-gray-150 p-6 gap-1 w-full shadow-sm">
      <div className="text-xs leading-4 text-left text-gray-550 uppercase">
        {title}
      </div>
      {renderContent()}
    </div>
  );
}
